module.exports = __webpack_public_path__ + "static/media/church.18e294cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/church.svg
// module id = 1950
// module chunks = 0